import React, { FC, useEffect, useRef, useState } from 'react'
import useCurrentUser from 'hooks/CurrentUser'
import { Redirect, Route, Switch } from 'react-router-dom'
import { NATIVE_PUBLIC_ROUTES, nativePublicPathGenerator } from './PublicRoutes'
import useAuthentication from 'hooks/Authentication'
import { Loader } from 'components/Loader/Loader'
import { getChannel } from 'api/channel/getChannel'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'
import { ConditionalRender } from 'components/ConditionalRender/ConditionalRender'

interface ProtectedRoutesProps {
  children: React.ReactNode
  company?: string
}

export const ProtectedRoutes: FC<ProtectedRoutesProps> = ({
  children,
  company
}) => {
  const currentUser = useCurrentUser()
  const { loggedIn } = useAuthentication()
  const isFirstVisit = useRef(true)

  const [companySubdomain, setCompanySubdomain] = useState<string | undefined>(
    company
  )
  const [loading, setLoading] = useState<boolean>(false)

  const fetchCompanySubdomain = async () => {
    if (!companySubdomain) {
      setLoading(true)
      try {
        const response = await getChannel(window.location.hostname)
        setCompanySubdomain(response?.subdomain)
      } catch (error) {
        console.error('Error fetching channel:', error)
      } finally {
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    if (isFirstVisit.current) {
      isFirstVisit.current = false
    }
  }, [])

  useEffect(() => {
    fetchCompanySubdomain()
  }, [company])

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    )
  }

  if (NATIVE_APP_HELPER.SOLID_SPORT_APP.IS_CURRENT_DOMAIN) {
    return <>{children}</>
  }

  if (!currentUser) {
    return (
      <Redirect
        exact
        to={nativePublicPathGenerator(
          NATIVE_PUBLIC_ROUTES.AUTH.ROOT,
          companySubdomain
        )}
      />
    )
  }

  if (
    currentUser &&
    window.location.pathname.includes(NATIVE_PUBLIC_ROUTES.ROOT)
  ) {
    return (
      <Redirect to={nativePublicPathGenerator('/feed', companySubdomain)} />
    )
  }
  if (currentUser) {
    return (
      <>
        {isFirstVisit.current ? (
          <Redirect to={nativePublicPathGenerator('/feed', companySubdomain)} />
        ) : (
          children
        )}
      </>
    )
  }
  return <div>Protected routes</div>
}
